import React, { useState } from "react";
import { useThemesContext } from "../../../../builder/context/ThemeProvider";
import ThemeStatusModal from "../themes/cards/status";
import Card from "./card";
import Placeholder from "./placeholder";
import MoreCard from "./more";

import "./index.scss";

const StoreList = () => {

    const [currentSchema, setCurrentSchema] = useState(null);
    const { jobStatus, library, libraryLoading } = useThemesContext();

    return <div className="store-card-container">

        {jobStatus && currentSchema ? <ThemeStatusModal theme={{ schema: currentSchema }} /> : null}

        {libraryLoading ? [1,2,3].map((key) => <Placeholder key={key} />) : null}
        {(library || []).map((t, key) => (
            <Card {...t} setCurrentSchema={setCurrentSchema} key={key} />
        ))}
        <MoreCard />
    </div>
}

export default StoreList;
